module.exports = __webpack_public_path__ + "img/ronin-mark.bfa94225.png";